export default "__VITE_ASSET__38883cda__"